module.exports = __webpack_public_path__ + "img/transaction.f2514a08.svg";